// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
const ChatActions = {
  UPDATE_CHAT: 'UPDATE_CHAT',
  OPEN_CHAT: 'OPEN_CHAT',
  ERROR_CONNECTING_CHAT: 'ERROR_CONNECTING_CHAT',
  ADD_MESSAGE_LOADER: 'ADD_MESSAGE_LOADER',
  REMOVE_LAST_MESSAGE: 'REMOVE_LAST_MESSAGE',
  UPDATE_SESSION_ID: 'UPDATE_SESSION_ID',
  UPDATE_CURRENT_POLL: 'UPDATE_CURRENT_POLL',
  SET_STATE: 'SET_STATE',
  CLEAR_STATE: 'CLEAR_STATE',
  CLEAR_CONVERSATION: 'CLEAR_CONVERSATION',
  UPDATE_SELECTED_BUTTONS: 'UPDATE_SELECTED_BUTTONS',
  SYNC_USER_INPUT_TO_BUTTONS: 'SYNC_USER_INPUT_TO_BUTTONS',
  UPDATE_FEEDBACK_FORM: 'UPDATE_FEEDBACK_FORM',
  REMOVE_FEEDBACK_REQUEST: 'REMOVE_FEEDBACK_REQUEST'
}

export default ChatActions
